export default __webpack_public_path__ + "img/7138cab577f43d4aad2bc73a8768de52.svg";